<template>
  <div class="search-block">
    <input
      class="table-search"
      :placeholder="placeholder"
      @input="filterData($event.target.value)"
    >
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    props: {
      tableData: {
        type: Array,
        default: () => []
      },
      placeholderMobile: {
        type: String,
        default: ''
      },
      placeholderDesktop: {
        type: String,
        default: ''
      }
    },

    computed: {
      ...mapGetters('device', [
        'isMobile'
      ]),

      placeholder () {
        if (this.isMobile) {
          return this.placeholderMobile
        }
        return this.placeholderDesktop
      }
    },

    methods: {
      filterData (value) {
        this.$emit('filterData', value)
      }
    }
  }
</script>

<style lang="scss" scoped rel="stylesheet/scss">
  @import "~assets/styles/common.scss";


  .search-block {
    position: relative;
    padding: 16px 23px;
    background: #f4f8dd;
    margin-bottom: 20px;

    @include bp-mf-tablet {
      padding: 16px;
      border-radius: 4px;
    }

    &:after {
      content: $line-icon-search;
      display: inline-block;
      min-width: 1px;
      min-height: 1px;
      font-family: $line-icon-font-family;
      position: absolute;
      right: 37px;
      font-size: em(20);
      line-height: 42px;
      color: $blue-medium;
      pointer-events: none;

      @include bp-mf-tablet {
        right: 31px;
      }
    }

    input {
      width: 100%;
      padding: 0 40px 0 16px;
      border-radius: 4px;
      font-size: 14px;
      font-weight: 500;

      @include input-placeholder() {
        color: $grey;
      }
    }
  }
</style>
